import { Box, CircularProgress, Typography } from '@mui/material'
import Chip from '@mui/material/Chip'
import { Stack } from 'components'
import { useMemo } from 'react'
import { useGetGlobalZones } from 'services/queries/useGetGlobalZones'
import { countries as Countries } from 'utils/constants'
import GlobalZonesTable from './GlobalZonesTable'

const GlobalZones = () => {
  const { data: globalZones, isLoading: isGlobalZonesLoading } =
    useGetGlobalZones()

  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        minWidth: 100,
        filterable: true,
        accessor: 'name',
        sortable: false,
      },
      {
        Header: 'Countries',
        minWidth: 200,
        filterable: true,
        accessor: 'countries',
        Cell: ({ row }) => {
          const countries = row.original.countries
          if (!countries || countries.length === 0) {
            return <span>None</span>
          }
          return (
            <Stack
              direction="row"
              spacing={1}
              wrap="wrap"
              row-gap={4}
              style={{ rowGap: '1rem' }}
            >
              {countries.map((country) => {
                const zoneCountry = Countries.getName(country, 'en', {
                  select: 'official',
                })
                if (!zoneCountry) {
                  return null
                }
                return (
                  <Chip
                    key={country}
                    size="medium"
                    label={zoneCountry || country}
                    variant="filled"
                    sx={{
                      '& .MuiChip-label': {
                        minWidth: '4rem',
                        fontSize: '15px',
                      },
                    }}
                  />
                )
              })}
            </Stack>
          )
        },
      },
    ],
    [],
  )

  if (isGlobalZonesLoading) {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', height: '300px' }}>
        <CircularProgress size={30} />
        <Typography variant="body1">Loading zones...</Typography>
      </Box>
    )
  }

  return (
    <GlobalZonesTable
      data={
        globalZones.data.map((zone) => {
          return { ...zone, countries: Array.from(new Set(zone.countries)) }
        }) || []
      }
      columns={columns}
    />
  )
}

export default GlobalZones
